// RTK Query base API configuration

import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQueryWithAuth } from './baseQuery';

export const baseApi = createApi({
  reducerPath: 'api',
  baseQuery: baseQueryWithAuth,
  tagTypes: [
    'User',
    'Service',
    'Review',
    'Analytics',
    'Payout',
    'PayoutSettings',
  ],
  endpoints: () => ({}),
});

// Export hooks for use in components
export const {
  // Auth endpoints will be injected here
  // Service endpoints will be injected here
  // Analytics endpoints will be injected here
  // Payout endpoints will be injected here
} = baseApi;
